<template>
	<h1 v-if="level === 1" :class="computedClass">{{ title }}</h1>
	<h2 v-else-if="level === 2" :class="computedClass">{{ title }}</h2>
</template>
<script>
export default {
	name: 'Heading',
	props: {
		title: {
			type: String,
			require: true,
		},
		level: {
			type: Number,
			default: 1,
		},
		hasBorderBottom: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		computedClass() {
			return ['title', `title-level${this.level}`, this.hasBorderBottom ? 'title--border' : ''];
		},
	},
};
</script>
<style lang="scss">
@import './Heading.scss';
</style>
